import Calendar, { CalendarType } from '@/models/calendar'
import { drop } from 'lodash'
import { ref } from 'vue'
import AppState from './../../states/app'

export class CalendarList {
  filters = ref({
    searchText: '',
    page: 1,
    group: '',
    calendar_type: '',
    status: 'all',
    ownedBy: 'anyone'
  })

  limit = 10

  constructor() {
    //
  }

  get offet() {
    return (this.filters?.value.page - 1) * this.limit
  }

  get calendarList(): Calendar[] {
    const { isServicesEnabled, selectedSettingsTab, globalTeams } = AppState
    const calendars = this.filters.value.group === '' ? this.filterdCalendars : this.groupCalendars
    return drop(calendars, this.offet).slice(0, this.limit)
  }

  get filterdCalendars() {
    const { searchText, status, calendar_type, ownedBy } = this.filters.value
    const { isServicesEnabled, isCalendarTypeSplitEnabled, selectedSettingsTab } = AppState
    const calendars = ownedBy === 'me' ? this.allOwnedByMeCalendars : this.allCalendars
    return calendars.filter(calendar => {
      return (
        (searchText === '' ||
          (calendar.name?.toLowerCase().includes(searchText.toLowerCase()) ||
            calendar.groupName?.toLowerCase().includes(searchText.toLowerCase()))) &&
        (status === 'all' ||
          (status === 'active' && calendar.isActive) ||
          (status === 'draft' && !calendar.isActive)) &&
        (calendar_type === '' || calendar_type === 'all' ||
          (calendar_type === CalendarType.EVENT &&
            calendar.calendarType === CalendarType.EVENT) ||
          (calendar_type === CalendarType.ROUND_ROBIN &&
            calendar.calendarType === CalendarType.ROUND_ROBIN) ||
          (calendar_type === CalendarType.COLLECTIVE &&
            calendar.calendarType === CalendarType.COLLECTIVE) ||
          (calendar_type === CalendarType.CLASS_BOOKING &&
            calendar.calendarType === CalendarType.CLASS_BOOKING) ||
          (calendar_type === CalendarType.SERVICE &&
            calendar.calendarType === CalendarType.SERVICE) ||
          (calendar_type === CalendarType.PERSONAL &&
            calendar.calendarType === CalendarType.PERSONAL)) &&
        (selectedSettingsTab === 'archived'
          ? calendar.calendarType === CalendarType.SERVICE
          : !(isCalendarTypeSplitEnabled || isServicesEnabled) || calendar.calendarType !== CalendarType.SERVICE)
      )
    })
  }

  get allCalendars(): Calendar[] {
    const currentLocationId = AppState.locationId
    const calendars = AppState.globalCalendars?.calendars || []
    const user = AppState.loggedInUserDetail
    const assigned_data_only = user?.permissions?.assignedDataOnly
    const role = user?.role
    if (assigned_data_only && role === 'user') {
      return calendars.filter(
        c =>
          user.userCalendar[currentLocationId] === c.id ||
          (c.teamMembers &&
            c.teamMembers.find(x => x.selected && x.userId === user?.id))
      )
    }
    const globalTeams = AppState.globalTeams
    const globalTeamsMap = new Map(globalTeams?.teams?.map(team => [team.id, team.name]))
    return calendars.map(calendar => {
      calendar.groupName = globalTeamsMap.get(calendar.providerId) || ''
      calendar.isActive = calendar.isActive !== false
      return calendar
    })
  }

  get allOwnedByMeCalendars(): Calendar[] {
    const currentLocationId = AppState.locationId
    const calendars = AppState.globalCalendars?.calendars || []
    const user = AppState.loggedInUserDetail
    const defaultPersonalCalendar = calendars.find(
      c => c.calendarType === CalendarType.PERSONAL && c.teamMembers && c.teamMembers.some(x => x.userId === user?.id) && c.isSystemGenerated === true
    )
    const filteredCalendars = calendars.filter(
      (c) => c.id !== defaultPersonalCalendar?.id
    )
    let assignedCalendars = filteredCalendars?.filter(
      c =>
        user?.userCalendar[currentLocationId] === c.id ||
        (c.teamMembers &&
          c.teamMembers.find(x => x.selected && x.userId === user?.id))
    )
    if (defaultPersonalCalendar) {
      assignedCalendars = [defaultPersonalCalendar, ...assignedCalendars]
    }
    const globalTeams = AppState.globalTeams
    const globalTeamsMap = new Map(globalTeams?.teams?.map(team => [team.id, team.name]))
    return assignedCalendars.map(calendar => {
      calendar.groupName = globalTeamsMap.get(calendar.providerId) || ''
      calendar.isActive = calendar.isActive !== false
      return calendar
    })
  }

  get nosTotalPages() {
    const calendars = this.filters.value.group === '' ? this.filterdCalendars : this.groupCalendars || []
    return Math.ceil(calendars.length / this.limit)
  }

  get groupWiseCount() {
    const filterdCalendars = this.filterdCalendars
    const groupWiseCount = filterdCalendars.reduce((acc: Record<string, number>, calendar) => {
      const group = calendar.providerId
      if (!acc[group]) {
        acc[group] = 0
      }
      acc[group]++
      return acc
    }, {} as Record<string, number>)
    return groupWiseCount
  }

  get groupCalendars() {
    const group = this.filters.value.group
    const filterdCalendars = this.filterdCalendars
    if (group === 'unassigned') {
      return filterdCalendars.filter(calendar => !calendar.providerId)
    }
    return filterdCalendars.filter(calendar => calendar.providerId === group)
  }
}
